import React from "react";
import { useAuth } from "../auth/AuthContext";
import { 
    Toast, 
    useToast, 
    useFormState, 
    useLoadingState, 
    useCommonNavigation,
    clientApi 
} from '../utils';

export default function AddClient() {
    const { user } = useAuth();
    const midwifeId = user?.sub;
    const { toastMessage, showToast } = useToast();
    const { error, setError } = useLoadingState(false);
    const { goToClients } = useCommonNavigation();
    
    const { form, handleChange, resetForm } = useFormState({
        email: "",
        firstName: "",
        lastName: "",
        dateOfBirth: "",
        allergies: ""
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        try {
            await clientApi.addClient(midwifeId, form);
            showToast("Client added successfully!");
            setTimeout(() => {
                goToClients();
            }, 2000);
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-10">
            <form
                onSubmit={handleSubmit}
                className="bg-white p-8 rounded-xl shadow-md w-full max-w-lg space-y-6"
            >
                <h2 className="text-2xl font-semibold text-emerald-700 mb-2">Add New Client</h2>

                <div>
                    <label htmlFor="email" className="block text-sm font-medium mb-1">
                        Client Email
                    </label>
                    <input
                        name="email"
                        type="email"
                        value={form.email}
                        onChange={handleChange}
                        className="w-full border border-gray-300 px-3 py-2 rounded"
                        required
                    />
                </div>

                <div>
                    <label htmlFor="firstName" className="block text-sm font-medium mb-1">
                        First Name
                    </label>
                    <input
                        name="firstName"
                        value={form.firstName}
                        onChange={handleChange}
                        className="w-full border border-gray-300 px-3 py-2 rounded"
                        required
                    />
                </div>

                <div>
                    <label htmlFor="lastName" className="block text-sm font-medium mb-1">
                        Last Name
                    </label>
                    <input
                        name="lastName"
                        value={form.lastName}
                        onChange={handleChange}
                        className="w-full border border-gray-300 px-3 py-2 rounded"
                        required
                    />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label htmlFor="dateOfBirth" className="block text-sm font-medium mb-1">
                            Date of Birth
                        </label>
                        <input
                            name="dateOfBirth"
                            type="date"
                            value={form.dateOfBirth}
                            onChange={handleChange}
                            className="w-full border border-gray-300 px-3 py-2 rounded"
                            required
                        />
                    </div>

                </div>

                <div>
                    <label htmlFor="allergies" className="block text-sm font-medium mb-1">
                        Allergies
                    </label>
                    <input
                        name="allergies"
                        value={form.allergies}
                        onChange={handleChange}
                        className="w-full border border-gray-300 px-3 py-2 rounded"
                        placeholder="e.g. Penicillin"
                    />
                </div>

                {error && <p className="text-red-500 text-sm">{error}</p>}

                <div className="flex justify-between mt-6">
                    <button
                        type="button"
                        onClick={goToClients}
                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-medium px-4 py-2 rounded"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-4 py-2 rounded"
                    >
                        Add Client
                    </button>
                </div>
            </form>

            {toastMessage && <Toast message={toastMessage} onClose={() => showToast("")} />}
        </div>
    );
}
